import React from 'react';
import PropTypes from 'prop-types';
import Header from 'cccisd-header';
import style from './style.css';

const Fortress = window.cccisd?.fortress;

const NavBar = ({ className }) => {
    return (
        <div className={`${style.navbar}`}>
            <Header
                primaryNavLinks={Fortress.auth() ? [{ url: '/manage#siteAdmin', label: 'Manage Videos' }] : []}
                containerClassName={className}
                wrapperClassName={style.wrapper}
                logoClassName={style.logo}
                logoLink={Fortress.auth() ? '/manage#siteAdmin' : '/'}
            />
        </div>
    );
};

NavBar.defaultProps = {
    className: 'container-fluid',
};

NavBar.propTypes = {
    className: PropTypes.string,
};

export default NavBar;
